/**
 * 变量来源
 * @author wangjiegj<wangjiegj@inspur.com>
 */

/**
 * 字段类型
 */
enum VariableSourceType {
  /**
   * BE
   */
  BE = 'BE',

  /**
   * VO
   */
  VO = 'VO',

  /**
   * 上下文
   */
  Context = 'Context',
}

export { VariableSourceType };

export const VariableSourceTypes: Array<{ index: number, text: string, value: VariableSourceType }> = [
  { index: 0, text: 'BE', value: VariableSourceType.BE },
  { index: 1, text: 'VO', value: VariableSourceType.VO },
  { index: 2, text: 'Context', value: VariableSourceType.Context }
];
